import { api } from "@/api";

const wasteCauseStore = {
  state: {
    wasteClauses: []
  },
  getters: {
    getWasteCauses(state) {
      return state.wasteClauses;
    },
    getActiveWasteCauses(state) {
      return state.wasteClauses.filter(x => x.is_deleted === false);
    }
  },
  mutations: {
    setWasteCauses(state, value) {
      state.wasteClauses = value;
    },
    addWasteCause(state, value) {
      state.wasteClauses.push(value);
    }
  },
  actions: {
    async loadWasteCauses(context, payload) {
      const res = await api.getInventoryWasteCauses(payload);
      context.commit("setWasteCauses", res);
    },
    async addWasteCause(context, payload) {
      const res = await api.postInventoryWasteCause(payload);
      if (res) {
        context.commit("addWasteCause", res);
      }
    }
  }
};

export default wasteCauseStore;
